<template>
  <div>
    <baidu-map class="map-box" :center="center" :zoom="16" @ready="handler">
      <!-- <bm-marker v-for="item in points" @click="clickHandler(item)" :key="item.id" :position="item.position"  :icon="{url: require('../../assets/image/worker_icon.png'), size: {width: 24, height: 40}}">
                </bm-marker> -->
    </baidu-map>
  </div>
</template>

<script>
// import myHttp from '@/untils/port';
import util from '@/untils/util'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      GpsArry: [],
      dianArry: [],
      polygonList: [], //多边形总数组
      obj: {
        zhuobiao: '',
        banjing: '',
      },
      listA: [],
      listB: [],
      createddata: null,
      createdList: [],
      center: {
        lng: 117.285033,
        lat: 31.86515,
      },
    }
  },
  created() {},
  methods: {
    async findProjectTowerList() {
      const data = await myHttp.findProjectTowerList({
        projectId: '1174625235200061441',
      })
      if (data.data.code == 200) {
        let listA = []
        let listB = []
        console.log('接口数据====》', data)
        this.createddata = data
        // 接口完整数据存入变量
        //  this.projectTowerList=data.data.data.projectTowerList.
        console.log('======完整接口数据', this.createddata)
        //  循环将接口信息处理成对象
        data.data.data.projectTowerList.forEach((item) => {
          item.setting = JSON.parse(item.setting)
          listA.push(item.setting)
          item.towerInfo = JSON.parse(item.towerInfo)
          listB.push(item.towerInfo)
          console.log(1)
        })

        //  将这两个数组存入data
        this.listA = listA
        this.listB = listB
        // 存了塔吊定位的数组
        console.log(this.listA)
        //  存了要画的圆的直径的数组
        console.log(this.listB)
      }
      //  创建对象存储定位以及半径
      this.obj = {
        zhuobiao: '',
        banjing: '',
      }
      //  存储定位及半径信息的数组
      this.createdList = []

      // 循环将定位和半径存入新对象并push到一个新的数组
      for (let index = 0; index < this.listA.length; index++) {
        console.log('index===>', index)
        const element = this.listA[index]
        console.log('element.towerLocationGps===', element)
        console.log('obj=====', this.obj)
        this.createdList.push({ zhuobiao: element.towerLocationGps })
      }
      for (let index = 0; index < this.listB.length; index++) {
        const element = this.listB[index]
        this.createdList[index].banjing = element.towerArmLength
        this.createdList[index].name =
          this.createddata.data.data.projectTowerList[index].towerName
        this.createdList[index].id =
          this.createddata.data.data.projectTowerList[index].deviceId
      }
      console.log('位置以及半径数组====》', this.createdList)
      // 地图初始视角
      let newbaidumap = util.map.WGSToBaidu(
        this.createdList[0].zhuobiao.latitude,
        this.createdList[0].zhuobiao.longitude
      )

      //  将列表中第一个位置信息设置为地图初始化后的视野
      this.center.lng = newbaidumap.lon
      this.center.lat = newbaidumap.lat
    },
    // 根据接口拿到要绘制的多边形的信息
    async getProProjectSceneSettingsList() {
      const data = await myHttp.getProProjectSceneSettingsList({
        projectId: '1174625235200061441',
      })
      if (data.data.code == 200) {
        console.log('多边形接口信息====》', data)
        const dataList = data.data.data.proProjectSceneSettingss
        console.log('proProjectSceneSettingss===>', dataList)
        let dataArry = []
        // 循环将接口信息的格式转换为对象
        for (let index = 0; index < dataList.length; index++) {
          console.log('多边形信息的index====》', index)
          const element = dataList[index]
          dataArry.push(JSON.parse(element.settings))
        }
        // 循环把所有的多边形坐标信息push到一个数组中
        let dbxobjArry = []
        for (let index = 0; index < dataArry.length; index++) {
          const element = dataArry[index]
          for (let index = 0; index < element.locationList.length; index++) {
            const item = element.locationList[index].locationInfoList
            dbxobjArry.push({ gpsList: item })
          }
        }

        console.log('处理后的多边形信息=====》', dataArry)
        console.log('所有多边形集合', dbxobjArry)
        this.polygonList = dbxobjArry //多边形总数组
      }
    },
    // 地图预处理
    handler({ BMap, map }) {
      this.findProjectTowerList()
      this.getProProjectSceneSettingsList()
      setTimeout(() => {
        console.log(BMap)
        console.log(map)
        // 地图对象
        this.map = map
        // 地图类
        this.BMap = BMap
        this.map.enableScrollWheelZoom()
        map.addControl(new BMap.ScaleControl())
        // 调用添加标注点的函数
        this.newMAPIcon()
      }, 3000)
    },
    newMAPIcon() {
      console.log(1)
      // 画圆形

      for (let index = 0; index < this.createdList.length; index++) {
        //  console.log(this.createddata.data.data.projectTowerList[index].towerName);
        console.log('han')
        const element = this.createdList[index]
        let yobj = util.map.WGSToBaidu(
          element.zhuobiao.latitude,
          element.zhuobiao.longitude
        )
        console.log(element.zhuobiao.latitude, element.zhuobiao.longitude)
        console.log('yobj', yobj)
        console.log('进入添加')
        //添加普通标注
        var marker = new BMap.Marker(new BMap.Point(yobj.lon, yobj.lat)) // 创建标注
        this.map.addOverlay(marker)
        // 添加圆形标注

        var circle = new BMap.Circle(
          //圆心坐标
          new BMap.Point(yobj.lon, yobj.lat),
          // 半径长度
          element.banjing,
          //  样式设置
          {
            strokeColor: '#1693F1',
            strokeWeight: 4,
            strokeOpacity: 0.5,
            fillColor: '#1693F1',
            fillOpacity: 0.3,
            // 设置圆形是否可以缩放
            enableEditing: false,
          }
        )
        console.log('开始添加')
        this.map.addOverlay(circle)
        console.log('添加成功')
        var radius = element.banjing //半径长度
        var itemAngle = 90 //角度
        // var dots={
        //   x:element.zhuobiao.longitude,
        //   y:element.zhuobiao.latitude
        // }//圆心坐标
        //   var x = element.zhuobiao.longitude + radius * Math.sin(itemAngle * 3.14 / 180);
        //   var y = element.zhuobiao.latitude + radius* Math.cos(itemAngle * 3.14 / 180);
        //   console.log('终止坐标===》',x,y);
        // 添加直线
        //   var polyline = new BMap.Polyline([
        // 		new BMap.Point(element.zhuobiao.longitude,element.zhuobiao.latitude),
        // 		new BMap.Point(x, y),

        // 	], {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5});
        // this.map.addOverlay(polyline);

        // var r=''
        // var a=''
        // var xa=x0+r*cos
        // 添加文字标注
        // 文字标注的地理位子
        var point = new BMap.Point(yobj.lon, yobj.lat)
        // 文字标注的内容
        var content = element.name
        var label = new BMap.Label(content, {
          //创建文本标注
          position: point, //设置标注的地理位置
          offset: new BMap.Size(10, 20), //设置标注的偏移量
        })
        this.map.addOverlay(label) //将标注添加到地图中
      }
      // 根据多边形的总数组绘制多边形
      for (let index = 0; index < this.polygonList.length; index++) {
        const element = this.polygonList[index]
        this.dianArry = []
        for (let index = 0; index < element.gpsList.length; index++) {
          const item = element.gpsList[index]
          // console.log('gps',item)
          item = util.map.WGSToBaidu(item.lat, item.lng)
          // this.GpsArry = this.GpsArry.push(item)
          var marker = new BMap.Marker(
            new BMap.Point(element.gpsList[0].lng, element.gpsList[0].lat)
          ) // 创建标注
          // this.map.addOverlay(marker)
          this.dianArry.push(new BMap.Point(item.lon, item.lat))
          var polygon = new BMap.Polygon(this.dianArry, {
            strokeColor: 'blue',
            strokeWeight: 1,
            strokeOpacity: 2.5,
          })
          this.map.addOverlay(polygon)
        }
      }

      // console.log(this.dianArry)

      // dianArry.push(new BMap.Point(117.285033,31.86515))

      // 绘制多边形
      //        var polygon =   new BMap.Polygon([
      //        new BMap.Point(117.285033,31.86515),
      //        new BMap.Point(117.285035,31.86517),
      //        new BMap.Point(116.394226,39.917988),
      //        new BMap.Point(116.401772,39.921364),
      //        new BMap.Point(116.41248,39.927893)
      //        ], {strokeColor:"blue", strokeWeight:10, strokeOpacity:2.5});
      //        this.map.addOverlay(polygon);
      //        添加标注点
      //        var point = new BMap.Point(117.285033,31.86515);
      //        var marker = new BMap.Marker(point);        // 创建标注
      //        this.map.addOverlay(marker);
      // 标注图标
      //  var worker_icon = new BMap.Icon(require('../assets/image/BG..png'), new BMap.Size(25,27),{
      //         anchor: new BMap.Size(12, 13),//这句表示图片相对于所加的点的位置mapStart
      //         imageSize:new BMap.Size(25, 27) //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
      //     });
      //     //
      //     this.worker = new BMap.Marker(new BMap.Point(117.285033,31.86515),{icon:worker_icon})
      //     this.map.addOverlay(this.worker);
      // if(this.curSn!=''){
      //     this.getData()
      // }
      //this.getAttendArea()
      // this.getLocation()
    },
  },
}
</script>

<style scoped>
.map-box {
  width: 100%;
  height: 46.875vw;
}
</style>